/**
 * Phase 4b — overlay candidate set.
 *
 * Filter the friends who have an active incoming share with the viewer down
 * to those who also appear in the poll's proposed invitee list. The list is
 * a union over four sources so the create flow, the edit flow with newly
 * added pending invitees, and the questing-group cascade all behave the
 * same way:
 *
 *   - saved `poll.participantIds`           (edit flow only)
 *   - selected questing group's `memberIds` (create + edit)
 *   - email invitees resolved to a uid      (only friends with an account
 *                                            resolve, which is the desired
 *                                            filter)
 *   - the poll creator                      (saved creatorId in edit, the
 *                                            viewer's own uid in create)
 *
 * The CF (`getSharedAvailabilityProjection`) intentionally does NOT enforce
 * any of this — it only checks that the active share exists. The invitee
 * filter is a UX quality-of-life rule, not a privacy gate.
 */
export function computeOverlayCandidateOwnerIds({
  incomingShareOwnerIds = [],
  participantIds = [],
  groupMemberIds = [],
  inviteeUidsFromEmails = [],
  creatorId = null,
} = {}) {
  if (!incomingShareOwnerIds.length) return [];
  const inviteeSet = new Set();
  for (const id of participantIds) if (id) inviteeSet.add(id);
  for (const id of groupMemberIds) if (id) inviteeSet.add(id);
  for (const id of inviteeUidsFromEmails) if (id) inviteeSet.add(id);
  if (creatorId) inviteeSet.add(creatorId);
  return incomingShareOwnerIds.filter((ownerId) => inviteeSet.has(ownerId));
}
